module.exports = __webpack_public_path__ + "src/assets/games/46/3.png";